module.exports = __webpack_public_path__ + "static/media/Jennifer Perchonok.97898f0d.png";